import { IAuthContext } from "@/interfaces"
import { ContextActions, ContextActionType } from "@/types/context"
import { useReducer } from "react"
import { initialState } from "./state"

export const contextReducer = (
  state: IAuthContext,
  action: ContextActions,
): IAuthContext => {
  switch (action.type) {
    case ContextActionType.SET_THEME:
      return {
        ...state,
        theme: action.payload.theme,
      }
    case ContextActionType.SET_USER:
      return {
        ...state,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        metadata: action.payload.metadata,
        isUser: action.payload.isUser,
        loading: action.payload.loading,
      }
    case ContextActionType.SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case ContextActionType.SET_GROUPS:
      return {
        ...state,
        listGroups: action.payload.listGroups,
      }
    case ContextActionType.ADD_CATEGORY:
      return {
        ...state,
        listCategory: [...state.listCategory, ...action.payload.listCategory],
      }
    case ContextActionType.DELETE_CATEGORY:
      return {
        ...state,
        listCategory: state.listCategory.filter(
          (group) => group.id !== action.payload.id,
        ),
      }
    case ContextActionType.DELETE_ITEM:
      const cleanGroups = state.listGroups?.map(({ group }) => {
        return {
          group: {
            ...group,
            items: group.items
              .map((item) => {
                if (item.id === action.payload.id) {
                  return {
                    ...item,
                    deleted: true,
                  }
                }
                return item
              })
              .filter((item) => !item.deleted),
          },
        }
      }) as IAuthContext["listGroups"]

      return {
        ...state,
        listGroups: cleanGroups,
      }

    case ContextActionType.DELETE_GROUP: {
      return {
        ...state,
        listGroups: state.listGroups?.filter(
          (group) => group.group.id !== action.payload.id,
        ),
      }
    }

    case ContextActionType.SET_GROUP_BD_ID: {
      return {
        ...state,
        groupBdId: action.payload.id,
      }
    }

    default:
      return state
  }
}
export const useStore = () => {
  const [state, dispatch] = useReducer(contextReducer, initialState)
  return [state, dispatch]
}
